export type Route = '/' | '/admin' | '/wine-list' | '/public-wine-list' | '/auth';

export interface RouterState {
  currentRoute: Route;
  params: Record<string, string>;
}

class Router {
  private listeners: ((route: Route) => void)[] = [];
  private currentRoute: Route = '/';
  private params: Record<string, string> = {};

  constructor() {
    // 初期ルートを設定
    this.currentRoute = this.getRouteFromUrl();
    this.params = this.getParamsFromUrl();
    
    // ブラウザの戻る/進むボタンに対応
    window.addEventListener('popstate', () => {
      this.currentRoute = this.getRouteFromUrl();
      this.params = this.getParamsFromUrl();
      this.notifyListeners();
    });
  }

  private getRouteFromUrl(): Route {
    const path = window.location.pathname;
    
    // 本番環境の/wine/パスに対応
    const normalizedPath = path.startsWith('/wine/') ? path.substring(5) : path;
    
    if (normalizedPath === '/admin' || normalizedPath === 'admin') {
      return '/admin';
    }
    if (normalizedPath.startsWith('/wine-list') || normalizedPath.startsWith('wine-list')) {
      return '/wine-list';
    }
    if (normalizedPath.startsWith('/public-wine-list') || normalizedPath.startsWith('public-wine-list')) {
      return '/public-wine-list';
    }
    if (normalizedPath === '/auth' || normalizedPath === 'auth') {
      return '/auth';
    }
    return '/';
  }

  private getParamsFromUrl(): Record<string, string> {
    const urlParams = new URLSearchParams(window.location.search);
    const params: Record<string, string> = {};
    
    // パスからユーザーIDを取得（/public-wine-list/PMO45jVheEMuJnzQyIDuXAK25GU2 形式）
    const path = window.location.pathname;
    if (path.startsWith('/public-wine-list/')) {
      const userId = path.split('/')[2];
      if (userId) {
        params.userId = userId;
      }
    } else if (path.startsWith('/wine-list/')) {
      const userId = path.split('/')[2];
      if (userId) {
        params.userId = userId;
      }
    }
    
    // クエリパラメータからユーザーIDを取得（?user=xxx 形式）
    const userId = urlParams.get('user');
    if (userId) {
      params.userId = userId;
    }
    
    return params;
  }

  private updateUrl(route: Route, params?: Record<string, string>) {
    let url = route;
    
    if (params && Object.keys(params).length > 0) {
      const urlParams = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        urlParams.set(key, value);
      });
      url += `?${urlParams.toString()}`;
    }
    
    window.history.pushState({}, '', url);
  }

  navigate(route: Route, params?: Record<string, string>) {
    this.currentRoute = route;
    this.params = params || {};
    this.updateUrl(route, params);
    this.notifyListeners();
  }

  getCurrentRoute(): Route {
    return this.currentRoute;
  }

  getParams(): Record<string, string> {
    return this.params;
  }

  subscribe(listener: (route: Route) => void) {
    this.listeners.push(listener);
    
    // 即座に現在のルートを通知
    listener(this.currentRoute);
    
    // クリーンアップ関数を返す
    return () => {
      this.listeners = this.listeners.filter(l => l !== listener);
    };
  }

  private notifyListeners() {
    this.listeners.forEach(listener => listener(this.currentRoute));
  }
}

// シングルトンインスタンス
export const router = new Router();


